import React from "react";
import styled from "styled-components";
import { spacing4, spacing8, spacing16, grey15 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFooter = styled.footer.withConfig({
  componentId: "sc-1ccsyeu-0"
})(["border-block-start:1px solid ", ";padding:calc(", " + ", ") ", ";"], grey15, spacing8, spacing4, spacing16);

/**
 * Use a footer to stick content at the bottom of the contextual menu.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Content inside the footer
 * @returns {React.ReactNode} The footer component
 */
const Footer = ({
  children,
  ...props
}) => /*#__PURE__*/_jsx(StyledFooter, {
  ...props,
  children: children
});
Footer.displayName = "Footer";
export default Footer;